import { Injectable, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SideBarService {

  constructor() {
  }
  //#region Subject Events
  public contentSideBar: Subject<TemplateRef<any>> = new Subject<TemplateRef<any>>();
  public contentDeActivate: Subject<() => Promise<any>> = new Subject<() => Promise<any>>();
  //#endregion

  //#region Public Methods
  setContentSideBar(contentSideBar: TemplateRef<any>) {
    this.contentSideBar.next(contentSideBar)
  }
  setContentDeActivate(contentDeActivate: () => Promise<any>) {
    this.contentDeActivate.next(contentDeActivate);
  }

  close() {
    this.setContentSideBar(null);
    this.setContentDeActivate(null);
  }
  //#endregion
}